import DefaultSelectedProvisional from "src/components/feature/SelectedProvisional";

const SelectedProvisional = () => {
  return <DefaultSelectedProvisional />;
};

export default SelectedProvisional;
